import React from "react";
import PropTypes from 'prop-types';

const Box = ({ children, currentURL, className }) => {
    return <div className={className ? className : ''}>
        {
            React.Children.toArray(children).filter(element => element?.type === Help).find(help => help?.props?.ayudaId === currentURL)
        }
    </div>
}

Box.propTypes = {
    /**
     * tipo de hijo content.help
     */
    children: PropTypes.any,
    /**
     * el id de ayuda debe coincidir con alguno de los ids de ayuda del componente Help para mostrar el contenido, de lo contrario no mostrara nada.
     */
    currentURL: PropTypes.string.isRequired,
    /**
     * cadena de clases css que se quieren aplicar al componente (div)
     */
    className: PropTypes.string
}

const Help = ({ children, className }) => {
    return <div className={className ? className : ''}>
        {children}
    </div>
}

Help.propTypes = {
    /**
     * Recibe cualquier tipo de elemento html o react component
     */
    children: PropTypes.any,
    /**
     * cadena de clases css que se quieren aplicar al componente (button)
     */
    className: PropTypes.string
}

export const Content = {
    Box,
    Help,
}